<template>
  <div class="mp-input" :id="'currency-' + currency.toString()">
    <!-- <a href="javascript:void(0)"  v-on:click="mpMinus()">
    <img src="../assets/images/subtract.png"  alt="subtract" class="mr-2 am-icons"></a>-->

    <b-form-input
      type="number"
      size="sm"
      min="0"
      @input="finalValue($event)"
      autocomplete="off"
      class="text-center p-0 ml-3 col-10"
      placeholder="0"
      v-negative-disable
    />
    <!-- <a href="javascript:void(0)"  v-on:click="mpPlus(currency)"><img src="../assets/images/add.png" alt="Add" class="ml-2 am-icons"></a> -->
  </div>
</template>

<script>
export default {
  name: "minus-plus",
  props: {
    currency: Number,
    type: String,
  },
  data() {
    return {
      newValue: 0,
      data: {
        currency: 0,
        value: 0,
        type: "",
      },
    };
  },
  mounted() {
    //    this.finalValue();
  },
  methods: {
    finalValue(newCurrency) {
      // console.log(newCurrency);
      this.newValue = newCurrency;
      if (this.newValue < 0) {
        this.newValue = 0;
      }
      this.data.currency = this.currency;
      this.data.value = this.currency * this.newValue;
      this.data.type = this.type;
      this.$emit("postdata", this.data);
    },
    mpMinus() {
      this.newValue = this.newValue - 1;
      if (this.newValue < 0) {
        this.newValue = 0;
      }
      this.data.currency = this.currency;
      this.data.value = this.currency * this.newValue;
      this.data.type = this.type;
      this.$emit("postdata", this.data);
    },
    mpPlus(newCurrency) {
      this.newValue = this.newValue + 1;
      //   console.log('Plus Click : '+ this.currency);
      this.data.currency = this.currency;
      this.data.value = this.currency * this.newValue;
      this.data.type = this.type;
      this.$emit("postdata", this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-control-sm {
  display: inline;
}
</style>
